module.exports = __webpack_public_path__ + "img/users.d23d3e94.svg";